import React, { memo } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { stripColor, alumStripColor } from "./defaults";
import { RowLayout } from "../../util/accordianStyles";
import useStripSelector from "./useStripSelector";
import { styled } from "@mui/material/styles";
import { Badge } from "@mui/material";

function StripAccordian() {
  const { checkMark, variant, handleClick, isAlum } = useStripSelector();

  const StyledBadge = styled(Badge)({
    "& .MuiBadge-badge": {
      backgroundColor: "#f0be07",
    },
  });

  return (
    <ReusableAccordian
      accordionName="strip"
      heading="Weather Strip Color"
      secondaryHeading="Select color"
    >
      <RowLayout>
        {isAlum
          ? alumStripColor.map((state) => (
              <div key={state.id} onClick={() => handleClick(state.label)}>
                <Choices
                  label={state.label}
                  variant={variant(state.label)}
                  checkMark={checkMark(state.label)}
                  wide={true}
                />
              </div>
            ))
          : stripColor.map((state) => (
              <StyledBadge badgeContent={state.isNew ? "New!" : undefined} style={{gap: "18px"}}>
                <div key={state.id} onClick={() => handleClick(state.label)}>
                  <Choices
                    label={state.label}
                    variant={variant(state.label)}
                    checkMark={checkMark(state.label)}
                    wide={true}
                  />
                </div>
              </StyledBadge>
            ))}
      </RowLayout>
    </ReusableAccordian>
  );
}

export default memo(StripAccordian);
